import {initialState, SearchStateModel} from './model';
import {inject, Injectable} from '@angular/core';
import {Action, createSelector, Selector, State, StateContext} from '@ngxs/store';
import {ClearSearchQueryAction, SetSearchStateAction} from './actions';
import {Router} from '@angular/router';

@State<SearchStateModel>({
  name: 'search',
  defaults: initialState
})
@Injectable()
export class SearchState {
  private readonly router = inject(Router);
  @Selector()
  static getSearchState(state: SearchStateModel): SearchStateModel {
    return state;
  }

  @Selector([SearchState.getSearchState])
  static getQuery(state: SearchStateModel) {
    return state.query;
  }

  @Selector([SearchState.getSearchState])
  static getSearchAnswerOverview(state: SearchStateModel) {
    return state.answer;
  }

  @Selector([SearchState.getSearchState])
  static getLoadingState(state: SearchStateModel) {
    return state.loading;
  }

  static getViewModel<T = Partial<SearchStateModel>>(keys: (keyof SearchStateModel)[]) {
    return createSelector([SearchState.getSearchState], (state: SearchStateModel) => keys.reduce((acc, key) => {
      return {
        ...acc,
        [key]: state[key]
      };
    }, {} as T));
  }

  @Action(SetSearchStateAction)
  setState({setState}: StateContext<SearchStateModel>, {state}: SetSearchStateAction) {
    setState(state);
  }

  @Action(ClearSearchQueryAction)
  clearQuery({patchState}: StateContext<SearchStateModel>) {
    patchState({query: ''});
  }
}
